import React, {PropsWithChildren} from 'react';
import {TextStyle, View} from 'react-native';
import {useStyles} from '../../hooks/styles';
import {StackHeaderTitleProps} from '@react-navigation/stack';
import {Text} from '../text';
import {useSelector} from 'react-redux';
import {themeSelector} from '../../../redux/selectors/runtime/theme';
import {VisImpStatus} from '../../models/visuallyImpairedSettings';

interface Props extends StackHeaderTitleProps {
  testID?: string;
  align: 'center' | 'left';
  title?: string | string[];
  numberOfLines?: number;
}

const RootMobileTitle: React.FC<PropsWithChildren<Props>> = (props: Props) => {
  const themeSettings = useSelector(themeSelector());
  const styles = useStyles(({theme}) => ({
    wrapper: {
      width: '100%',
    },
    text: {
      ...theme.fonts.h6,
      textAlign: props.align,
    },
  }));

  const isVisImp = themeSettings.visuallyImpaired === VisImpStatus.Active;

  const titleBlock = Array.isArray(props.title) ? (
    props.title.map((text, idx) => (
      <TitleBlock
        testID={`title-block-${idx}-${props.testID}-id`}
        key={idx}
        style={styles.text}
        numberOfLines={props.numberOfLines}
        isVisImp={isVisImp}>
        {text}
      </TitleBlock>
    ))
  ) : (
    <TitleBlock
      testID={`title-block-1-${props.testID}-id`}
      style={styles.text}
      numberOfLines={props.numberOfLines}
      isVisImp={isVisImp}>
      {props.title ?? props.children}
    </TitleBlock>
  );

  return (
    <View testID={props.testID} style={styles.wrapper}>
      {titleBlock}
    </View>
  );
};

const TitleBlock: React.FC<
  PropsWithChildren<{style: TextStyle; numberOfLines?: number; testID: string; isVisImp: boolean}>
> = (props) => {
  return (
    <Text
      style={props.style}
      numberOfLines={props.numberOfLines ?? 1}
      ellipsizeMode='tail'
      adjustsFontSizeToFit={!props.isVisImp}
      minimumFontScale={0.5}>
      {props.children}
    </Text>
  );
};

export default RootMobileTitle;
